"use strict";

var _regeneratorRuntime = require("/builds/sites/europa-fm-pwa/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}
/* eslint-disable */


var raInitBool = true;
var raPromisesVar = [];
var raPromisesHB = [];
var slots = [];
var raiCont = 0;
var raiContPrebidId = 0;
var slotsRefresh_1 = [];
var raiDevice = null;
var raAdUnits;
var raData;
var raDataJSON;
var videoUrl;
var newSlotsScroll = [];
var timer = 0;
var raiScriptsLoad = false;
var raiDebug = {
  active: false,
  style: 'background: #fff; color: #0E263F; border: 1px solid red; padding: 1px;',
  styleError: 'background-color: #0E263F; color: #fff; border: 1px solid red; padding: 1px;',
  stylePromise: 'background: #00263f; color: #fff; border: 1px solid white; padding: 1px;'
};

var raDeviceType = function raDeviceType() {
  var ua = navigator.userAgent;

  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return 'tablet';
  }

  if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
    return 'mobile';
  }

  return 'desktop';
};

raiDevice = raDeviceType();

if (raiDevice != null) {
  if (window.innerWidth >= 1200) {
    raiDevice = 'desktop';
  } else if (window.innerWidth >= 768 && window.innerWidth <= 1299) {
    raiDevice = 'tablet';
  } else if (window.innerWidth >= 0 && window.innerWidth <= 767) {
    raiDevice = 'mobile';
  }
}

var raConf = {
  GPT: true,
  Prebid: '4_42_1',
  biddersInfo: '04_05_2021',
  definedSlots: '',
  adUnit: '',
  seccion: '',
  placements: {},
  bidders: ['richaudience', 'appnexus'],
  AdUnitsDfp: {
    networkId: '21735183016',
    definedSlots: true,
    definedBidderConfig: true,
    slots: [],
    slotsScroll: [],
    contadorSlots: 0,
    contador_pag: 0
  },
  DinamicRefresh: {
    active: false,
    num_refresh: 5,
    time: 15000
  },
  Roadblock: false,
  Debug: {
    active: false
  },
  Publisher: 'CPM',
  Timeout: 1300,
  TimeoutBackup: 3000,
  Players: {
    JWPlayer: {
      active: false,
      tag: true
    }
  },
  fetchJSON: false,
  logs: {
    Promise: {
      Phase_1: {
        GPT: {
          raInit: false,
          raEnd: false,
          raTime: 0
        },
        Prebid: {
          raInit: false,
          raEnd: false,
          raTime: 0
        },
        Data: {
          raInit: false,
          raEnd: false,
          raTime: 0
        }
      },
      Phase_2: {},
      Phase_3: {}
    }
  }
};

var _default = function _default(definedSlots, adUnit, seccion, placements, bidders, isFirstPage) {
  if (window.location.search.includes('ra_debug=true')) {
    raiDebug.active = true;
    console.log('%cRAWP_core', raiDebug.style, raConf);
  }

  if (typeof isFirstPage !== 'undefined' && isFirstPage) {
    raInitBool = isFirstPage;
    raConf.AdUnitsDfp.contador_pag = 1;
    raConf.definedSlots = [];
    raConf.adUnit = '';
    raConf.seccion = '';
    raConf.AdUnitsDfp.slots = [];

    if (typeof pbjs !== 'undefined') {
      pbjs.removeAdUnit();
    }
  } else {
    raConf.AdUnitsDfp.contador_pag = raConf.AdUnitsDfp.contador_pag + 1;
  }

  raConf.definedSlots = definedSlots;
  raConf.adUnit = adUnit;
  raConf.seccion = seccion;

  if (raInitBool) {
    raConf.placements = placements;
    raiInfo();
    var raInterval = setInterval(function () {
      if (raConf.fetchJSON) {
        clearInterval(raInterval);
        var raiJsonConfig = fetch('//cdn3.richaudience.com/ab083674fb8200b877a6983126e4477d/a3media/pb_wrapper/index.php', {
          method: 'GET',
          headers: {
            Accept: 'application/json'
          }
        }).then(function (response) {
          return response.json();
        }).then(function (data) {
          setSlots(data);
          raInitBool = false;
        })["catch"](function (error) {
          return console.log(error);
        });
      } else if (typeof raConf.definedSlots !== 'undefined' && raConf.definedSlots != null) {
        clearInterval(raInterval);
        setSlots();
        raInitBool = false;
      }
    }, 100);
  } else {
    setSlots(null);
  }
};

exports["default"] = _default;

function setSlots(data) {
  try {
    newSlotsScroll = [];
    raConf.AdUnitsDfp.slotsScroll = [];

    if (data != null) {
      raDataJSON = data;
    }

    var raPlcmSkin = raConf.placements.top[0];
    raConf.definedSlots.forEach(function (a3) {
      if (typeof raConf.AdUnitsDfp.slots.find(function (sl) {
        return sl.name == a3.getSlotId().getDomId();
      }) == 'undefined') {
        a3.setTargeting('pagina', raConf.AdUnitsDfp.contador_pag.toString());

        if (!a3.getSlotId().getDomId().includes('interstitial')) {
          raiDebug.active ? console.log('%cRAWP_core', raiDebug.style, '<------------->') : null;
          raiDebug.active ? console.log('%cRAWP_core', raiDebug.style, raConf.placements) : null;
          var raiPlacement = null;

          if (typeof a3.getTargeting('pos')[0] != 'undefined') {
            if (a3.getTargeting('pos')[0].includes('top')) {
              if (a3.getTargeting('pos')[0].includes('top2') && raConf.placements.top.length == 5) {
                raConf.placements.top.shift();
                raiPlacement = raConf.placements[a3.getTargeting('pos')[0].slice(0, -1)].shift();
              } else if (raPlcmSkin.length > 0 && raInitBool != false) {
                raiPlacement = raPlcmSkin;
                raConf.placements.top.shift();
              } else {
                raiPlacement = raConf.placements[a3.getTargeting('pos')[0].slice(0, -1)].shift();
              }
            } else if (!a3.getTargeting('pos')[0].includes('floor_ad')) {
              raiPlacement = raConf.placements[a3.getTargeting('pos')[0].slice(0, -1)].shift();
            } else if (a3.getSlotId().getDomId() == 'gpt-passback') {
              raiPlacement = raConf.placements[a3.getSlotId().getDomId()].shift();
            } else if (a3.getTargeting('pos')[0].includes('floor_ad')) {
              raiPlacement = raConf.placements[a3.getTargeting('pos')[0]].shift();
            }
          }

          var slotTemp = {
            id: raConf.adUnit,
            name: a3.getSlotId().getDomId(),
            pos: a3.getTargeting('pos')[0],
            richaudience: raiPlacement.richaudience,
            appnexus: parseInt(raiPlacement.appnexus),
            size: a3.getSizes().map(function (sz) {
              return sz.width != null && sz.height != null ? [sz.width, sz.height] : null;
            }).filter(function (e) {
              return e !== null;
            })
          };
          raiDebug.active ? console.log('%cRAWP_core', raiDebug.style, slotTemp) : null;
          raiDebug.active ? console.log('%cRAWP_core', raiDebug.style, raConf.placements) : null;

          if (slotTemp.size.length > 1) {
            slotTemp.size = raiDebug.active ? slotTemp.size.slice(1, 8) : slotTemp.size.sort().reverse();
          }

          raConf.AdUnitsDfp.slots.push(slotTemp);
          raConf.AdUnitsDfp.slotsScroll.push(slotTemp);
          newSlotsScroll.push(a3);
          raConf.AdUnitsDfp.contadorSlots++;
        }
      } else {
        raiDebug.active ? console.log('%cRAWP_core', raiDebug.style, 'Slot is already defined') : null;
      }
    });

    if (!raInitBool) {
      pbjs.removeAdUnit();
      preloadAdsConfig(false);
    } else {
      raAdUnits = raConf.AdUnitsDfp.slots;
      raiScriptsLoad ? preloadAdsConfig(true) : raInit();
    }
  } catch (e) {
    raiSaveAds();
    console.log(e);
  }
}

function raInit() {
  raiDebug.active ? console.log('%cRAWP_core', raiDebug.style, 'Slots raConf definedSlots:', raConf.definedSlots) : null;

  if (raConf.AdUnitsDfp.slots.length != 0) {
    raData = raConf.AdUnitsDfp.slots;
  }

  raPromisesVar.push(new Promise(function (res, fail) {
    if (raConf.GPT) {
      try {
        var raScGPT = document.createElement('script');
        raScGPT.async = 'async';
        raScGPT.src = '//www.googletagservices.com/tag/js/gpt.js';
        document.querySelector('head').appendChild(raScGPT);
        res('googletag_load');
      } catch (e) {
        res('googletag_unLoad');
      }
    } else {
      res('googletag_load');
    }
  }).then(function (res) {
    var raConfGPT = raConf.logs.Promise.Phase_1.GPT;
    raiDebug.active ? console.log('%cRAWP_Promise: Phase 1 - LoadGPT', raiDebug.stylePromise) : null;
    raConfGPT.raInit = true;

    if (res == 'googletag_load') {
      raConfGPT.raEnd = true;
    } else if (res == 'googletag_unLoad') {
      raiDebug.active ? console.log('%cRAWP_core', raiDebug.styleError, "Fail Appned script GPT ".concat(e)) : null;
      raConfGPT.raEnd = false;
    }

    raiDebug.active ? console.log('%cRAWP_Promise: Phase 1 - LoadGPT - END', raiDebug.stylePromise) : null;
    raConfGPT.raTime = timer;
    raiLog();
  }));
  raPromisesVar.push(new Promise(function (res, fail) {
    if (raConf.Prebid) {
      try {
        var raScPrebid = document.createElement('script');
        raScPrebid.async = 'async';
        raScPrebid.src = 'https://cdnjs.atresmedia.com/header-bidding/prebid.js';
        document.querySelector('head').appendChild(raScPrebid);
        var pbjs = pbjs || {};
        pbjs.que = pbjs.que || [];
        res('pbjs_load');
      } catch (e) {
        res(e);
      }
    }
  }).then(function (res) {
    var raConfPrebid = raConf.logs.Promise.Phase_1.Prebid;
    raiDebug.active ? console.log('%cRAWP_Promise: Phase 1 - LoadPrebid', raiDebug.stylePromise) : null;
    raConfPrebid.raInit = true;

    if (res == 'pbjs_load') {
      raiDebug.active ? console.log('%cRAWP_core', raiDebug.style, 'Append script Prebid') : null;
      raConfPrebid.raEnd = true;
    } else if (res != 'pbjs_load') {
      raiDebug.active ? console.log('%cRAWP_core', raiDebug.styleError, "Fail Appned script Prebid ".concat(res)) : null;
      raConfPrebid.raEnd = false;
    }

    raiDebug.active ? console.log('%cRAWP_Promise: Phase 1 - LoadPrebid - END', raiDebug.stylePromise) : null;
    raConfPrebid.raTime = timer;
    raiLog();
  }));
  raPromisesVar.push(new Promise(function (res, fail) {
    try {
      if (typeof raData !== 'undefined') {
        if (raData.toString().includes('Promise')) {
          raData.then(function (result) {
            raAdUnits = result;
            raiDebug.active ? console.log('%cRAWP_core', raiDebug.style, 'Data info:', result) : null;
            res('raData_load');
          });
        } else {
          raAdUnits = raData;
          raiDebug.active ? console.log('%cRAWP_core', raiDebug.style, 'Data info:', raData) : null;
          res('raData_load');
        }
      } else {
        res('raData_unLoad');
      }
    } catch (e) {
      res(e);
    }
  }).then(function (res) {
    var raConfData = raConf.logs.Promise.Phase_1.Data;
    raiDebug.active ? console.log('%cRAWP_Promise: Phase 1 - LoadData', raiDebug.stylePromise) : null;
    raiDebug.active ? console.log('%cRAWP_Promise: Phase 1 - LoadData - END', raiDebug.stylePromise) : null;
    raConfData.raInit = true;

    if (res == 'raData_load') {
      raConfData.raEnd = true;
    } else if (res != 'raData_load') {
      raiDebug.active ? console.log('%cRAWP_core', raiDebug.styleError, 'raData is undefined') : null;
      raiDebug.active ? console.log('%cRAWP_core', raiDebug.styleError, "error in load Data: ".concat(res)) : null;
      raConfData.raEnd = false;
    }

    raiLog();
  }));
  raiScriptsLoad = true;
  Promise.allSettled(raPromisesVar).then(function (res) {
    return preloadAdsConfig(true);
  })["catch"](function (e) {
    return console.log(e);
  });
}

function preloadAdsConfig(firstLoad) {
  raiDebug.active ? console.log('%cRAWP_Promise: Phase 2 - LOAD GPT / PREBID / DATA', raiDebug.stylePromise) : null;
  raPromisesHB.push(new Promise(function (res, fail) {
    raiDebug.active ? console.log('%cRAWP_Promise: Phase 2 - LOAD OBJ PREBID', raiDebug.stylePromise) : null;

    if (!firstLoad) {
      raAdUnits = raConf.AdUnitsDfp.slotsScroll;
    }

    try {
      var raConfigPrebid = function raConfigPrebid(pbjs) {
        try {
          pbjs.que.push(function () {
            pbjs.setConfig({
              enableSendAllBids: false,
              priceGranularity: 'dense',
              userSync: {
                filterSettings: {
                  iframe: {
                    bidders: '*',
                    filter: 'include'
                  }
                }
              },
              cache: {
                url: 'https://prebid.adnxs.com/pbc/v1/cache'
              },
              consentManagement: {
                gdpr: {
                  cmpApi: 'iab',
                  timeout: 8000,
                  defaultGdprScope: true
                }
              }
            });
            pbjs.addAdUnits(raAdUnitsFormatted);
            pbjs.requestBids({
              timeout: raConf.Timeout,
              bidsBackHandler: function bidsBackHandler() {
                if (raConf.Players.JWPlayer.active) {
                  raiDebug.active ? console.log('%cRAWP_JWPlayer', raiDebug.style, 'is active ') : null;

                  if (raConf.Players.JWPlayer.tag) {
                    raiDebug.active ? console.log('%cRAWP_JWPlayer', raiDebug.style, 'Get tag DFP') : null;
                    videoUrl = pbjs.adServers.dfp.buildVideoUrl({
                      adUnit: raAdUnits[3],
                      params: {
                        iu: '/19968336/prebid_cache_video_adunit',
                        output: 'vast'
                      }
                    });
                    raiDebug.active ? console.log('%cRAWP_JWPlayer', raiDebug.style, "VAST autogenerated: ".concat(videoUrl)) : null;
                    raPrebidVideoPlayer(videoUrl);
                  }
                }

                googletag.cmd.push(function () {
                  pbjs.setTargetingForGPTAsync();
                });
              }
            });
          });
        } catch (e) {
          raiDebug.active ? console.log('%cRAWP_core', raiDebug.styleError, "fail in pbjs setConfig: ".concat(e)) : null;
          raiDebug.active ? console.log('%cRAWP_Promise: Phase 2 - LOAD OBJ PREBID - END', raiDebug.stylePromise) : null;
          return 'fail_prebid';
        }
      };

      var raAdUnitsFormatted = raAdUnits.map(function (slot) {
        var device = raDeviceType();
        var raSize = slot.size;
        var raiObj = {
          code: slot.name,
          bids: []
        };
        raiObj.mediaTypes = {
          banner: {
            sizes: raSize
          }
        };

        if (raConf.bidders.includes('richaudience') && slot.richaudience != null) {
          raiObj.bids.push({
            bidder: 'richaudience',
            params: {
              pid: slot.richaudience,
              supplyType: 'site'
            }
          });
        }

        if (raConf.bidders.includes('appnexus') && slot.appnexus != null) {
          raiObj.bids.push({
            bidder: 'appnexus',
            params: {
              placementId: slot.appnexus
            }
          });
        }

        if (raConf.bidders.includes('ix')) {
          for (var x = 0; x < raSize.length; x++) {
            raiObj.bids.push({
              bidder: 'ix',
              params: {
                siteId: slot.ixPlacement,
                size: raSize[x]
              }
            });
          }
        }

        return raiObj;
      });
      var result;

      if (typeof pbjs !== 'undefined') {
        raiDebug.active ? console.log('%cRAWP_core', raiDebug.style, 'load pbjs config') : null;
        raConfigPrebid(pbjs);
        pbjs.onEvent('setTargeting', function () {
          pbjs.offEvent('setTargeting');
          res('ok_prebid');
        });
      } else {
        raiDebug.active ? console.log('%cRAWP_core', raiDebug.styleError, 'not load pbjs, we apply a timeout') : null;
        var raiAttempts = 0;
        var raiLoadPbjs = setInterval(function () {
          if (typeof pbjs !== 'undefined') {
            clearInterval(raiLoadPbjs);
            raConfigPrebid(pbjs);
            pbjs.onEvent('setTargeting', function () {
              pbjs.offEvent('setTargeting');
              res('ok_prebid_second_attemp');
            });
          } else {
            raiDebug.active ? console.log('%cRAWP_core', raiDebug.style, "pbjs load attemp: ".concat(raiAttempts)) : null;
            raiAttempts++;
          }
        }, 200);
      }
    } catch (e) {
      console.log(e);
      raiDebug.active ? console.log('%cRAWP_Promise: Phase 2 - LOAD OBJ PREBID - END', raiDebug.stylePromise) : null;
      raiDebug.active ? console.log('%cRAWP_core', raiDebug.styleError, "fail generate slots: ".concat(e)) : null;
      res('fail_prebid');
    }
  }).then(function (res) {
    if (res == 'ok_prebid' || res == 'ok_prebid_second_attemp') {
      raiDebug.active ? console.log('%cRAWP_core', raiDebug.style, 'done setConfig pbjs ') : null;
      raiDebug.active ? console.log('%cRAWP_Promise: Phase 2 - LOAD OBJ PREBID - END', raiDebug.stylePromise) : null;
    }

    if (res = 'fail_prebid') {}
  })); // THEN

  raPromisesHB.push(new Promise(function (res, fail) {
    raiDebug.active ? console.log('%cRAWP_Promise: Phase 2 - LOAD AMAZON', raiDebug.stylePromise) : null;
    var cont = 0;
    var checkAmazon = false;

    while (cont < 10) {
      cont++;

      if (cont == 10) {
        raiDebug.active ? console.log('%cRAWP_Promise: Phase 2 - LOAD AMAZON - END', raiDebug.stylePromise) : null;
        checkAmazon = true;
        res('ok_amazon');
      }
    }

    setTimeout(function () {
      if (!checkAmazon) {
        raiDebug.active ? console.log('%cRAWP_Promise: Phase 2 - LOAD AMAZON - END', raiDebug.stylePromise) : null;
        fail('fail_amazon');
      }
    }, raConf.Timeout);
  }));
  raPromisesHB.push(new Promise(function (res, fail) {
    raiDebug.active ? console.log('%cRAWP_Promise: Phase 2 - LOAD SLOTS DFP', raiDebug.stylePromise) : null;

    try {
      var raiDefineSlot = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(slot) {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  return _context2.abrupt("return", new Promise(function (res, fail) {
                    var AdSlot;
                    googletag.cmd.push(function () {
                      AdSlot = googletag.defineSlot("/".concat(raConf.AdUnitsDfp.networkId, "/").concat(slot.name), slot.sizes, slot.id).addService(googletag.pubads());
                      googletag.pubads().disableInitialLoad();
                      googletag.pubads().enableSingleRequest();
                      googletag.enableServices();
                      raiDebug.active ? console.log('%cRAWP_core', raiDebug.style, 'Slot info:', AdSlot) : null;
                      slots.push(AdSlot);
                      res('ok');
                    });
                  }));

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function raiDefineSlot(_x2) {
          return _ref2.apply(this, arguments);
        };
      }();

      raiDebug.active ? console.log('%cRAWP_core', raiDebug.style, 'Data Network info:', raConf.AdUnitsDfp) : null;
      raiCont = 0;

      if (raConf.AdUnitsDfp.definedSlots == true) {
        raiDebug.active ? console.log('%cRAWP_Promise: Phase 2 - LOAD SLOTS DFP - END', raiDebug.stylePromise) : null;
        res('slots_dfp');
      } else {
        raConf.AdUnitsDfp.slots.forEach( /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(slot) {
            var result;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return raiDefineSlot(slot);

                  case 2:
                    result = _context.sent;
                    raiCont++;

                    if (slots.length == raiCont) {
                      raiDebug.active ? console.log('%cRAWP_Promise: Phase 2 - LOAD SLOTS DFP - END', raiDebug.stylePromise) : null;
                      res('generate_slots_dfp');
                    }

                  case 5:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      }
    } catch (e) {
      raiDebug.active ? console.log('%cRAWP_core', raiDebug.styleError, "fail generate slots: ".concat(e)) : null;
      raiDebug.active ? console.log('%cRAWP_Promise: Phase 2 - LOAD SLOTS DFP - END', raiDebug.stylePromise) : null;
      res('fail_generate_slots_dfp');
    }
  }));
  Promise.allSettled(raPromisesHB).then(function (res) {
    return raDisplayAds(res, firstLoad);
  })["catch"](function (e) {
    return raiDebug.active ? console.log('%cRAWP_core', raiDebug.style, 'Error in HB/GPT/AMZ:', e) : null;
  });
}

function raDisplayAds(res, firstLoad) {
  raiDebug.active ? console.log('%cRAWP_Promise: Phase 3 - FUNCION FINAL', raiDebug.stylePromise) : null;
  var allFramLoad = false;
  var amazonLoad = false;
  var prebidLoad = false;
  var allFailed = false;

  if (res[2].value == 'generate_slots_dfp' || res[2].value == 'slots_dfp') {
    if (typeof slots !== 'undefined' && slots != '') {
      raiDebug.active ? console.log('%cRAWP_core', raiDebug.style, 'Slots info:', slots) : null;
    } else if (typeof raConf.definedSlots !== 'undefined') {
      raiDebug.active ? console.log('%cRAWP_core', raiDebug.style, 'Slots info:', raConf.definedSlots) : null;
      raiDebug.active ? console.log('%cRAWP_core', raiDebug.style, 'Slots Scroll info:', newSlotsScroll) : null;
    }

    if (typeof pbjs !== 'undefined') {
      raiDebug.active ? console.log('%cRAWP_core', raiDebug.style, 'pbjs info: ', pbjs) : null;
    }

    googletag.cmd.push(function () {
      if (typeof googletag !== 'undefined') {
        raiDebug.active ? console.log('%cRAWP_core', raiDebug.style, 'googletag info: ', googletag) : null;
      }
    });

    if (res[0].value == 'ok_prebid' && res[1].value == 'ok_amazon') {
      raiDebug.active ? console.log('%cRAWP_core', raiDebug.style, 'All frameworks HB loaded') : null;
      allFramLoad = true;
    } else if (res[0].value == 'fail_prebid' && res[1].value == 'ok_amazon') {
      raiDebug.active ? console.log('%cRAWP_core', raiDebug.style, 'Only framework Amazon is loaded') : null;
      amazonLoad = true;
    } else if (res[0].value == 'ok_prebid' && res[1].value == 'fail_amazon') {
      raiDebug.active ? console.log('%cRAWP_core', raiDebug.style, 'Only framework Prebid is loaded') : null;
      prebidLoad = true;
    } else if (res[0].value == 'fail_prebid' && res[1].value == 'fail_amazon') {
      raiDebug.active ? console.log('%cRAWP_core', raiDebug.style, 'All frameworks HB failed') : null;
      allFailed = true;
    }

    new Promise(function (res, fail) {
      if (!raConf.Roadblock) {
        res('ok_keyValues');
      } else {
        var raiKeyValues = setInterval(function () {
          if (prebidLoad || allFramLoad) {
            try {
              for (slot in pbjs.getAdserverTargeting()) {
                if (typeof pbjs.getAdserverTargeting()[slot].hb_pb === 'string') {
                  if (raConf.Roadblock) {
                    var bidsWin = pbjs.getHighestCpmBids();

                    if (bidsWin.find(function (a) {
                      return a.dealId == 'ramkt';
                    })) {
                      googletag.cmd.push(function () {
                        googletag.pubads().getSlots().filter(function (e) {
                          return e.getSizes().find(function (size) {
                            if (size.l == 120 && size.j == 600 || size.m == 120 && size.j == 600 || size.l == 160 && size.j == 600 || size.m == 160 && size.j == 600 || size.l == 120 && size.j == 1000 || size.m == 120 && size.j == 1000 || size.l == 160 && size.j == 1000 || size.m == 160 && size.j == 1000 || size.l == 450 && size.j == 1000 || size.m == 450 && size.j == 1000 || size.l == 120 && size.j == 1001 || size.m == 120 && size.j == 1001 || size.l == 160 && size.j == 1001 || size.m == 160 && size.j == 1001 || size.l == 450 && size.j == 1001 || size.m == 450 && size.j == 1001 || size.m == 300 && size.j == 250) {
                              return size;
                            }
                          });
                        }).forEach(function (a) {
                          return a.setTargeting('hb_deal_richaudience', 'ramkt_r');
                        });
                      });
                    }

                    raiDebug.active ? console.log('%cRAWP_core', raiDebug.style, 'Set targeting for Roadblocks') : null;
                  }

                  clearInterval(raiKeyValues);
                  res('ok_keyValues');
                }
              }
            } catch (e) {
              raiDebug.active ? console.log('%cRAWP_core', raiDebug.styleError, "fail check slots: ".concat(e)) : null;
            }
          }
        }, 100);
        setTimeout(function () {
          clearInterval(raiKeyValues);
          fail('fail_keyValues');
        }, raConf.Timeout);
      }
    }).then(function (message) {
      raiDebug.active ? console.log('%cRAWP_core', raiDebug.style, 'Refresh first attempt') : null;

      if (firstLoad) {
        googletag.cmd.push(function () {
          googletag.pubads().refresh();
        });
      } else {
        googletag.cmd.push(function () {
          googletag.pubads().refresh(newSlotsScroll);
        });
      }
    })["catch"](function (e) {
      raiDebug.active ? console.log('%cRAWP_core', raiDebug.style, 'Fail setTargeting in slots GPT') : null;

      if (firstLoad) {
        googletag.cmd.push(function () {
          googletag.pubads().refresh();
        });
      } else {
        googletag.cmd.push(function () {
          googletag.pubads().refresh(newSlotsScroll);
        });
      }
    });
  }
}

function raiRefeshSlotsAuto() {
  raiDebug.active ? console.log('%cRAWP_data', raiDebug.style, 'DynamicRefresh is active: ', raConf.DinamicRefresh) : null;
  var raiConutRefresh = 0;
  var raiRefresh = setInterval(function () {
    raiDebug.active ? console.log('%cRAWP_data', raiDebug.style, "Refresh: ".concat(raiConutRefresh)) : null;

    if (!slotsRefresh_1.length >= 1) {
      slots.forEach(function (index) {
        return slotsRefresh_1.push(index.getAdUnitPath());
      });
    }

    pbjs.que.push(function () {
      pbjs.requestBids({
        timeout: raConf.Timeout,
        adUnitCodes: slotsRefresh_1,
        bidsBackHandler: function bidsBackHandler() {
          pbjs.setTargetingForGPTAsync(slotsRefresh_1);
        }
      });
    });
    googletag.pubads().refresh(slots);
    raiConutRefresh >= raConf.DinamicRefresh.num_refresh ? clearInterval(raiRefresh) : raiConutRefresh++;
  }, raConf.DinamicRefresh.time);
}

function raPrebidVideoPlayer(tag, mp4) {
  mp4 = 'https://vjs.zencdn.net/v/oceans.mp4';

  try {
    raiDebug.active ? console.log('%cRAWP_JWPlayer', raiDebug.style, "Vast from Publisher: ".concat(tag)) : null;
    raiDebug.active ? console.log('%cRAWP_JWPlayer', raiDebug.style, "MP4 from Publisher: ".concat(mp4)) : null;
    raiDebug.active ? console.log('%cRAWP_JWPlayer', raiDebug.style, 'Object: ', raPrebidVideo) : null;
    raPrebidVideo.setup({
      file: mp4,
      width: 640,
      height: 480,
      advertising: {
        client: 'vast',
        tag: videoUrl
      }
    });
  } catch (e) {
    raiDebug.active ? console.log('%cRAWP_JWPlayer', raiDebug.style, "Fail Player".concat(e)) : null;
  }
}

function raiInfo() {
  var raiInfo_iframe = document.createElement('iframe');
  raiInfo_iframe.id = 'raiInfoRA';
  raiInfo_iframe.src = 'https://bridge.richaudience.com/ab083674fb8200b877a6983126e4477d/GenericWrapper/raiInfo.html';
  raiInfo_iframe.style = 'width:400px; height:600px; position:fixed; right:0; top:0; z-index:9999999; background-color:white;';
  !raiDebug.active ? raiInfo_iframe.style = 'display: none;' : null;
  raiInfo_iframe.style = 'display: none;';
  document.body.appendChild(raiInfo_iframe);
}

function raiLog(pbjsResponse) {
  if (typeof pbjsResponse !== 'undefined') {
    console.log(pbjsResponse);
    window.document.querySelector('#raiInfoRA').contentWindow.postMessage({
      message: 'pbjsSlots',
      logs: JSON.stringify(pbjsResponse)
    }, '*');
  } else {
    var r = setTimeout(function () {
      window.document.querySelector('#raiInfoRA').contentWindow.postMessage({
        message: 'info',
        logs: JSON.stringify(raConf)
      }, '*');
    }, 500);
  }
}

function raiSaveAds() {
  raiDebug.active ? console.log('%cRAWP_SaveAds', raiDebug.style, 'Refresh ADS:') : null;

  if (typeof googletag !== 'undefined') {
    googletag.cmd.push(function () {
      googletag.pubads().refresh();
    });
  }
}